<template>
  <div v-if="product">
    <div class="container">
      <div>
        <bread-crumbs :bread="breadCrambs" />
      </div>
    </div>
    <div class="container">
      <div class="image">
        <image-slider  :images="product.images"/>
      </div>
      <div class="description" v-if="product">
        <h1>{{ product.name }}</h1>
        <p v-if="product.fullName.length !== 0">{{ product.fullName }}</p>
        <span class="price">{{ product.price }} <span>₽ с НДС </span></span>
        <span>(цена за {{ product.unit }}.)</span>
        <div class="text" v-html="product.text"></div>
        <div class="controlls">
<!--          <a target="_blank" href="#" class="ye-button button-big">Заказать</a>-->
        </div>
      </div>
    </div>

    <div class="tabs">
      <tabs :tabs="tabs"/>
    </div>


    <div v-if="product.additionalIds.length !== 0 || product.analogIds.length !== 0" class="additional">
      <div v-if="product.additionalIds.length !== 0" class="addProducts">
        <p>Сопутствующие товары</p>
        <products :products="product.additionalIds"/>
      </div>
      <div v-if="product.analogIds.length !== 0" class="analogs">
        <p>Похожие товары</p>
        <products :products="product.analogIds"/>
      </div>
    </div>
  </div>
</template>

<script>

import axios from "axios";
import ImageSlider from "@/components/Product/ImageSlider";
import BreadCrumbs from "@/components/Product/BreadCrumbs";
import Products from "@/components/Products";
import Tabs from "@/components/Product/Tabs";

export default {
  name: "Product",
  components: {Tabs, Products, BreadCrumbs, ImageSlider},
  props: ['id'],
  watch: {
    id(){
      this.breadCrambs = [{
        name: 'Каталог',
        path: '/',
      }]
      this.getProduct()
      this.tabs = []
      window.scrollTo(0, 0);
    }
  },
  data() {
    return {
      product: null,
      activeTab: 0,
      breadCrambs: [
        {
          name: 'Каталог',
          path: '/',
        },
      ],
      tabs: []
    }
  },
  methods: {
    getProduct() {
      axios.get(process.env.VUE_APP_API_URL, { params: {
          product: 'get',
          id: this.id
        }})
          .then((response) => {
            this.product = response.data[0]
            this.breadCrambs.push({name: this.product.categoryName, path: '/category/' + this.product.category }, {name: this.product.name})

            if (this.product.text2.length !== 0) {
              this.tabs.push({
                name: 'Технические характеристики',
                content: this.product.text2
              })
            }

            if (this.product.text3.length !== 0) {
              this.tabs.push({
                name: 'Материалы',
                content: this.product.text3
              })
            }

            if (this.product.packing.length !== 0) {
              this.tabs.push({
                name: 'Упаковка',
                content: this.product.packing
              })
            }
          })
    },
  },
  mounted() {
    this.getProduct()
  },
}
</script>



<style scoped>

.tabs {
  margin: 35px 0 0 0;
}

.additional p {
  font-size: 19px;
  font-weight: 500;
  margin-bottom: 16px;
  text-align: left;
}

.additional div {
  margin-bottom: 30px;
}

.mat-text {
  text-align: left;
}

.tech-text {
  text-align: left;
}
.controlls {
  margin: 35px 0;
  position: relative;
}
.price {
  font-size: 46px;
  font-weight: 500;

}
.price span {
  font-size: 25px;
}
.container {
  display: flex;
}
.description {
  padding: 20px;
  padding-top: 0;
  text-align: left;
  width: 50%;
}
.image {
  width: 50%;
}
.text {

}

h1 {
  margin-top: 0;
  font-size: 27px;
  font-weight: 500;
}

ul {
  list-style: none;
  padding: 0;
  display: flex;
  gap: 10px;
}

ul li {
  white-space: nowrap;
  margin-right: 40px;
  font-size: 19px;
  font-weight: 500;
  color: #0f202a;
  line-height: 23px;
  padding-bottom: 3px;
  cursor: pointer;
}

.text ul {
  padding: 0;
}

.active-tab {
  border-bottom: 3px solid #0f202a;
}

@media (max-width: 750px) {
  .image, .description {
    width: 100%;
  }
  .container {
    flex-direction: column;
  }

  .description {
    padding: 0;
    margin-top: 25px;
  }
}

</style>

<style>

.table-base {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #f2f2f2;
}

.table-base td {
  border: 1px solid #f2f2f2;
  padding: 10px 15px;
  font-size: 13px;
  line-height: 22px;
  font-weight: 400;
  color: #0f202a;
  vertical-align: top;
}

td.td-header {
  background: #f2f2f2;
  font-weight: 500;
  font-size: 14px;
  border-color: #fff;
}
</style>